import { useMemo } from 'react';

import { useShowBackerInfo } from '@givebacks/api/backer';
import { NavLink, useNavigate } from 'react-router-dom';
import { Anchor } from 'ui';

import { AddCardModal } from '../../../components/shared/Cards/AddCard/AddCardNew';
import AddCardSuccessModal from '../../../components/shared/Cards/AddCard/AddCardSuccessModal';
import { useAddCardModal } from '../../../components/shared/Cards/AddCard/useAddCardModal';
import { useHandleAddCardClick } from '../../../hooks/useHandleAddCardClick';
import { WaysToGiveBackLayout } from './WaysToGiveBack.Layout';

const Dine = () => {
  const { data: backer, refetch: refetchBacker } = useShowBackerInfo();
  const { addCardProps, openAddCardModal, successProps } = useAddCardModal({
    onClose: refetchBacker,
  });
  const { handleAddCardClick } = useHandleAddCardClick({ onSuccess: refetchBacker });

  const navigate = useNavigate();

  const cta = useMemo(() => {
    if (backer?.home?.linked_shop_to_give_card) {
      return {
        label: 'View Restaurants',
        onClick: () => navigate('/rewards/dining'),
      };
    } else {
      return { label: 'Link Card', onClick: () => handleAddCardClick(openAddCardModal) };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backer?.home?.linked_shop_to_give_card]);

  return (
    <>
      <WaysToGiveBackLayout
        title="Dine"
        cta={cta}
        tagline="Help your favorite causes earn donations when you dine in person with your credit card."
        copy={
          <>
            Simply link your card, pay with it as usual, and 10,000+ participating restaurants will
            donate to{' '}
            <Anchor component={NavLink} to="/causes">
              your favorite causes
            </Anchor>{' '}
            at no cost to you!
          </>
        }
        howItWorks={{
          listItems: [
            'Link your credit cards in the Givebacks app.',
            'Explore the “Earn: In-Store” tab in Givebacks for nearby locations.',
            'Dine in-person at these always-available establishments; no activation required.',
            `A portion of your bill is donated to your favorite causes!`,
          ],
        }}
        successMessage={backer?.home?.linked_shop_to_give_card ? 'Card Linked' : undefined}
      />
      <AddCardModal {...addCardProps} />
      <AddCardSuccessModal {...successProps} />
    </>
  );
};

export { Dine };
